import Wallet from './index';

export default { path: '/home/wallet', component: Wallet };
